import _extends from "@babel/runtime/helpers/extends";
import { DomainWithEllipsis } from '../DomainWithEllipsis';
import React from 'react';
import { Box, Text } from '@wix/design-system';
import s from './DomainText.css';
const AVERAGE_GLYPH_WIDTH_RATIO = 0.58;
export const DomainText = _ref => {
  let {
    overflowStrategy = 'ellipsis',
    minFontSize = '1.125rem',
    maxFontSize = '1.75rem',
    forceFontSize,
    ...props
  } = _ref;
  if (overflowStrategy === 'ellipsis') {
    return /*#__PURE__*/React.createElement(DomainWithEllipsis, props);
  }
  const {
    textComponent,
    textComponentProps,
    children,
    dataHook,
    className
  } = props;
  const Component = textComponent || Text;
  const domainStr = (children == null ? void 0 : children.toString()) ?? '';
  const scaleStyle = {
    '--domain-scale': 1 / (AVERAGE_GLYPH_WIDTH_RATIO * (domainStr.length || 1)),
    '--domain-min-font-size': minFontSize,
    '--domain-max-font-size': maxFontSize,
    ...(forceFontSize && {
      '--domain-force-font-size': forceFontSize
    })
  };
  return /*#__PURE__*/React.createElement(Box, {
    display: "inline",
    style: scaleStyle
  }, /*#__PURE__*/React.createElement(Component, _extends({}, textComponentProps, {
    dataHook: dataHook,
    className: [s.autoScale, className].filter(Boolean).join(' ')
  }), children));
};
//# sourceMappingURL=DomainText.js.map